import { render, staticRenderFns } from "./ButtonStrongSquare.vue?vue&type=template&id=4754ca4d&scoped=true&lang=pug&"
import script from "./ButtonStrongSquare.vue?vue&type=script&lang=ts&"
export * from "./ButtonStrongSquare.vue?vue&type=script&lang=ts&"
import style0 from "./ButtonStrongSquare.vue?vue&type=style&index=0&id=4754ca4d&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4754ca4d",
  null
  
)

export default component.exports